import React from 'react';
import {
  Participant,
  useCurrentParticipant,
  useUpdateParticipant,
} from '@app/api';
import { Formik } from 'formik';
import { InformationPaneLayout } from './components/InformationPaneLayout';
import { useToast } from '@app/core';
import { Demographic, Location, Personal } from '../components/ProfileFields';
import { useTranslation } from 'react-i18next';

export const PersonalProfile = () => {
  const toast = useToast();
  const { t } = useTranslation();

  const { data: participant } = useCurrentParticipant();
  const { mutateAsync: updateParticipant } = useUpdateParticipant(
    participant?.id,
  );

  const submit = async (values: Participant) => {
    try {
      await updateParticipant(values);
      toast.saved();
    } catch (e) {
      toast.exception(e);
      throw e;
    }
  };

  if (!participant) {
    return null;
  }

  return (
    <Formik onSubmit={submit} initialValues={participant}>
      <InformationPaneLayout
        icon="ri-user-3-line"
        title={t('participantSpace.profile.personalProfile')}
      >
        <Demographic />
        <Location />
        <Personal />
      </InformationPaneLayout>
    </Formik>
  );
};
